<template>
<div>
    <h5 class="rule-title" v-b-toggle="'condition-' + rowNumber">
        <otif-icon icon="toggle-open" class="when-closed"/>
        <otif-icon icon="toggle-close" class="when-opened"/>

        <span class="position-relative">
            <span class="rule-title-text">{{row[1].length}} Conditions</span>
        </span>
    </h5>
    <b-collapse :id="'condition-' + rowNumber" class="OTRulesConditionTbl">
        <ul>
            <li v-for="(condition,idx) in row[1]" :key="'cond-' + idx">
                {{ condition.name }}
            </li>
        </ul>
    </b-collapse>

</div>
</template>

<script>

export default {
    props: ['row', 'rowNumber'],
}

</script>